
import React from 'react';
import ResetHeader from './reset-password/ResetHeader';
import ResetEmailSent from './reset-password/ResetEmailSent';
import ResetForm from './reset-password/ResetForm';
import ResetPasswordError from './reset-password/ResetPasswordError';
import { useResetPassword } from './reset-password/useResetPassword';

const ResetPasswordForm = () => {
  const {
    email,
    setEmail,
    loading,
    error,
    resetSent,
    rateLimited,
    cooldownTime,
    handleResetPassword
  } = useResetPassword();

  return (
    <div className="space-y-4">
      <ResetHeader />

      <ResetPasswordError error={error} rateLimited={rateLimited} />

      {resetSent ? (
        <ResetEmailSent />
      ) : (
        <ResetForm
          email={email}
          setEmail={setEmail}
          handleResetPassword={handleResetPassword}
          loading={loading}
          rateLimited={rateLimited}
          cooldownTime={cooldownTime}
        />
      )}
    </div>
  );
};

export default ResetPasswordForm;
